import { createSlice } from "@reduxjs/toolkit";

import {
  AddSchedulingCommentAction,
  AddSchedulingEstimateAction,
  getAllClientSchedulingListAction,
  getAllUsersSchedulingListAction,
  getClientJobSchedulingListAction,
  getClientUserSchedulingListAction,
  getManagerNewRequestList,
  getSingleJobsScheduledListAction,
  getSchedulingBandWidthAction,
  getSchedulingCalendar,
  getSchedulingCommentListAction,
  getSchedulingEmployeeApprovedListAction,
  getSchedulingReEstimateListAction,
  getSchedulingUserViewListAction,
  getViewRequestAction,
  updateRequestAction,
  revokeSchedulingRequestAction,
  getAllUserMappedToJobAction,
  getUserAvailabilityReportAction,
} from "@/redux/scheduling/action";
import { initialState } from "@/redux/scheduling/initialState";
import { schedulingReducer } from "@/redux/scheduling/reducer";
import type { SchedulingTypes } from "@/redux/scheduling/schedulingTypes";

export const schedulingSlice = createSlice({
  name: "scheduling",
  initialState,
  reducers: schedulingReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getSchedulingUserViewListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSchedulingUserViewListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;
        const { success, message, status_code, result, total_count } = payload;
        if (success === 0) {
          return {
            // ...state,
            // fetching: false,
            // error: message,
            // statusCode: status_code,
            // success,
            // schedulingUserViewListing: result,
            // userViewListTotal: total_count,
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,

          fetching: false,

          success,

          schedulingUserViewListing: result,

          userViewListTotal: total_count,
        };
      }
    );

    builder.addCase(
      getSchedulingUserViewListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSchedulingEmployeeApprovedListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSchedulingEmployeeApprovedListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;
        const { success, message, status_code, result, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          employeeApprovedList: result,
          employeeAprrovedTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getSchedulingEmployeeApprovedListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSchedulingCommentListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        commentFetching: true,
      })
    );

    builder.addCase(
      getSchedulingCommentListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;
        const { success, message, status_code, result, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            commentFetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          commentFetching: false,
          success,
          commentList: result,
          commentListTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getSchedulingCommentListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        commentFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSchedulingBandWidthAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSchedulingBandWidthAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, message, status_code, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          previousHours: result?.hours,
          dailyHours: result,
          // userViewListTotal:total_count
        };
      }
    );

    builder.addCase(
      getSchedulingBandWidthAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      AddSchedulingEstimateAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      AddSchedulingEstimateAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            fetching: false,
            // error: error.message,
          };
        } else {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            success,
            message,
          };
        }
      }
    );

    builder.addCase(
      AddSchedulingEstimateAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getManagerNewRequestList.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getManagerNewRequestList.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;
        const { success, message, status_code, result, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          schedulingManagerViewNewRequestsListing: result,
          managerNewRequestCount: total_count,
        };
      }
    );

    builder.addCase(
      getManagerNewRequestList.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(getViewRequestAction.pending, (state: SchedulingTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getViewRequestAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          requestView: result,
          message,
          // userViewListTotal:total_count
        };
      }
    );

    builder.addCase(
      getViewRequestAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      AddSchedulingCommentAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        commentFetching: true,
      })
    );

    builder.addCase(
      AddSchedulingCommentAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success,
            statusCode: status_code,
            commentFetching: false,
          };
        }
        return {
          ...state,
          commentFetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      AddSchedulingCommentAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        commentFetching: false,
      })
    );

    builder.addCase(
      getSchedulingReEstimateListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSchedulingReEstimateListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;

        const { success, message, status_code, result, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          reEstimateDataList: result,
          reEstimateDataTotalCount: total_count,
        };
      }
    );

    builder.addCase(
      getSchedulingReEstimateListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSchedulingCalendar.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSchedulingCalendar.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        //  const {data}=payload;
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          calendarData: result,
          message,
          // userViewListTotal:total_count
        };
      }
    );

    builder.addCase(
      getSchedulingCalendar.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(updateRequestAction.pending, (state: SchedulingTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateRequestAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateRequestAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllUsersSchedulingListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllUsersSchedulingListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          allusersScheduleList: result[0]?.data,
          allusersScheduleTotalCount: result[0]?.user_count,
        };
      }
    );

    builder.addCase(
      getAllUsersSchedulingListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllClientSchedulingListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllClientSchedulingListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          allClientScheduleList: result[0]?.data,
          allClientScheduleTotalCount: result[0]?.total_count,
        };
      }
    );

    builder.addCase(
      getAllClientSchedulingListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getClientUserSchedulingListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientUserSchedulingListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          clientUserSchedulingList: result[0]?.data ? result[0]?.data : [],
          clientUserSchedulingListTotal: result[0]?.user_count,
        };
      }
    );

    builder.addCase(
      getClientUserSchedulingListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getClientJobSchedulingListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientJobSchedulingListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          clientJobSchedulingList: result[0]?.data ? result[0]?.data : [],
          clientJobSchedulingTotal: result[0]?.job_count,
        };
      }
    );

    builder.addCase(
      getClientJobSchedulingListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getSingleJobsScheduledListAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleJobsScheduledListAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, sum_of_total_hours, result } =
          payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          singleJobScheduledHoursSum: sum_of_total_hours,
          singleJobScheduledHoursList: result,
        };
      }
    );

    builder.addCase(
      getSingleJobsScheduledListAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getAllUserMappedToJobAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllUserMappedToJobAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, sum_of_total_hours, result } =
          payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          allUserMappedToJob: result[0]?.data ? result[0]?.data : [],
          clientJobSchedulingTotal: result[0]?.user_count,
        };
      }
    );

    builder.addCase(
      getAllUserMappedToJobAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getUserAvailabilityReportAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getUserAvailabilityReportAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
          usersAvailabilityReportData: result[0]?.data,
          usersAvailabilityTotalCount: result[0]?.user_count,
          daysTotal: result[0]?.day_totals[0]?.day_totals,
        };
      }
    );

    builder.addCase(
      getUserAvailabilityReportAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      revokeSchedulingRequestAction.pending,
      (state: SchedulingTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      revokeSchedulingRequestAction.fulfilled,
      (state: SchedulingTypes, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      revokeSchedulingRequestAction.rejected,
      (state: SchedulingTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );
  },
});
export const {
  resetSchedulingUserViewListing,
  resetSchedulingError,
  resetSchedulingSuccess,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingFetching,
  resetSchedulingPrevoiusHour,
  resetSchedulingUserViewTotalCount,
  resetManagerNewRequest,
  resetSchedulingCommentListing,
  resetSchedulingApprovedListing,
  resetSchedulingApproveTotalCount,
  resetManagerNewRequestCount,
  resetReEstimateDataList,
  resetReEstimateDataTotalCount,
  resetCalendarData,
  resetRequestView,
  resetDailyHours,
  resetAllusersScheduleList,
  resetAllusersScheduleTotalCount,
  resetAllClientScheduleList,
  resetAllClientScheduleTotalCount,
  resetClientUserSchedulingList,
  resetClientUserSchedulingListTotal,
  resetClientJobSchedulingList,
  resetClientJobSchedulingTotal,
  resetSingleJobScheduledHoursSum,
  resetJobScheduledHoursList,
  resetAllUserMappedToJobList,
  resetUsersAvailabilityReportData,
  resetUsersAvailabilityTotalCount,
} = schedulingSlice.actions;
